import { Box, FormControl, IconButton, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import CustomInput from '../../components/inputs/CustomInputs';
import DeleteIcon from '@mui/icons-material/Delete';

const AddProductItem = ({ fields, setFields, loading }) => {
    const handleDeleteItem = (index) => {
        const updatedItems = fields?.item?.filter((_, inx) => inx !== index);
        setFields({ ...fields, err: "", item: updatedItems });
    };

    return (
        <Box mt={2}>
            {fields?.item?.length > 0 &&
                fields?.item?.map((val, inx) => {
                    if (!val) return null;
                    return (
                        <Box key={inx} display={"flex"} flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"} width={"100%"} gap={2}>
                            <Box width={"57%"}>
                                <CustomInput
                                    disabled={loading}
                                    value={val.name}
                                    onChange={(e) => {
                                        const updateditem = [...fields?.item];
                                        updateditem[inx] = {
                                            ...updateditem[inx],
                                            name: e.target.value,
                                        };
                                        setFields({ ...fields, err: "", item: updateditem });
                                    }}
                                    type="text"
                                    label={"Item Name*"}
                                />
                            </Box>
                            <Box width={"57%"}>
                                <CustomInput
                                    disabled={loading}
                                    value={val.solution}
                                    onChange={(e) => {
                                        const updateditem = [...fields?.item];
                                        updateditem[inx] = {
                                            ...updateditem[inx],
                                            solution: e.target.value,
                                        };
                                        setFields({ ...fields, err: "", item: updateditem });
                                    }}
                                    type="text"
                                    label={"Solution*"}
                                />
                            </Box>
                            <Box width={"43%"}>
                                <CustomInput
                                    disabled={loading}
                                    value={val.price}
                                    onChange={(e) => {
                                        const updateditem = [...fields?.item];
                                        updateditem[inx] = {
                                            ...updateditem[inx],
                                            price: Number(e.target.value),
                                        };
                                        setFields({ ...fields, err: "", item: updateditem });
                                    }}
                                    type="text"
                                    label={"Price*"}
                                />
                            </Box>
                            {/* <Box width={"30%"}>
                                <FormControl fullWidth>
                                    <InputLabel>Item Type</InputLabel>
                                    <Select
                                        value={val.type}
                                        label="Item Type"
                                        onChange={(e) => {
                                            const updateditem = [...fields?.item];
                                            updateditem[inx] = {
                                                ...updateditem[inx],
                                                type: e.target.value,
                                            };
                                            setFields({ ...fields, err: "", item: updateditem });
                                        }}
                                    >
                                        <MenuItem value={"physical_damage"}>Physical Damage</MenuItem>
                                        <MenuItem value={"Repairable"}>Repairable</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box> */}
                            <Box>
                                <IconButton
                                    color="error"
                                    onClick={() => handleDeleteItem(inx)}
                                    aria-label="delete"
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </Box>
                        </Box>
                    );
                })}
        </Box>
    );
};

export default AddProductItem;
